import { Rating } from '../../common/types/common';

export function getImpactLevelFromLabel(label?: string | number): number {
  switch (label) {
    case 'Breakthrough':
      return 5;
    case 'Transformative':
      return 3;
    case 'Incremental':
      return 1;
    default:
      return 0;
  }
}

export const keyToLabel = (key: string) => {
  switch (key) {
    case 'revenue_growth':
      return 'Revenue Growth';
    case 'customer_experience':
      return 'Customer Experience';
    case 'process_productivity':
      return 'Process Productivity';
    case 'employee_productivity':
      return 'Employee Productivity';
    case 'cost_savings':
      return 'Cost Savings';
    default:
      return key;
  }
};

export const getBadgeColor = (rating: Rating) => {
  switch (rating) {
    case 'High':
      return { bgColor: '#BEF2B2', color: '#429230' };
    case 'Medium':
      return { bgColor: '#F2ECB2', color: '#928D30' };
    case 'Low':
      return { bgColor: '#ffcdd2', color: '#C62828' };
    default:
      return { bgColor: 'transparent', color: 'black' };
  }
};

export const getBadgeColorRating = (rating: Rating) => {
  const normalized = rating?.toUpperCase();
  switch (normalized) {
    case 'HIGH':
      return { bgColor: '#7FAA3A', color: '#429230' };
    case 'MEDIUM':
      return { bgColor: '#FFC000', color: '#928D30' };
    case 'LOW':
      return { bgColor: '#FF0000', color: '#C62828' };
    default:
      return { bgColor: 'transparent', color: 'black' };
  }
};

export const scoreToLabel = (score: number): Rating => {
  if (score >= 8) return 'High';
  if (score >= 5) return 'Medium';
  return 'Low';
};

/**
 * @param timestamp - The timestamp string to format (e.g., from API)
 * @param options - Optional formatting options
 * @returns Formatted time string (e.g., "06:58 PM" or "03 Nov, 06:58 PM")
 */
export function formatTimestamp(
  timestamp?: string,
  options?: {
    includeDate?: boolean;
    locale?: string;
  }
): string {
  if (!timestamp) return '';

  try {
    let cleaned = timestamp.replace(/(\.\d{3})\d*/, '$1');

    if (!/[zZ]|[\+\-]\d{2}:?\d{2}$/.test(cleaned)) {
      cleaned += 'Z';
    }

    const date = new Date(cleaned);
    if (isNaN(date.getTime())) return '';

    const locale = options?.locale || undefined;

    // Extract day and month for date part
    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleDateString(locale, { month: 'short' });

    // Extract hours, minutes, and AM/PM for time part
    const hours12 = date.getHours() % 12 || 12;
    const hours = hours12.toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

    return `${day} ${month}, ${hours}:${minutes} ${ampm}`;
  } catch {
    return '';
  }
}

export const handleScrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const buildIdQuery = (ids: string[]): string => {
  if (!ids || ids.length === 0) return '';

  const idParam = ids.join(',');

  return `${idParam}`;
};
